import playground960 from '../../assets/images/responsive/playground-960.webp';
import playground1440 from '../../assets/images/responsive/playground-1440.webp';
import playground1920 from '../../assets/images/responsive/playground-1920.webp';
import vereskovaya960 from '../../assets/images/responsive/vereskovaya-960.webp';
import vereskovaya1440 from '../../assets/images/responsive/vereskovaya-1440.webp';
import vereskovaya1920 from '../../assets/images/responsive/vereskovaya-1920.webp';
import lake960 from '../../assets/images/responsive/lake-960.webp';
import lake1440 from '../../assets/images/responsive/lake-1440.webp';
import lake1920 from '../../assets/images/responsive/lake-1920.webp';
import entrance960 from '../../assets/images/responsive/entrance-960.webp';
import entrance1440 from '../../assets/images/responsive/entrance-1440.webp';
import entrance1920 from '../../assets/images/responsive/entrance-1920.webp';

export interface PlaceMedia {
  id: string;
  src?: string;
  srcSet?: string;
  width?: number;
  height?: number;
  alt: string;
  placeholder: string;
  recommendedFileName: string;
}

// Add future project photography by setting only `src` on the matching item.
// Recommended destination: public/images/places/.
export const placeMedia = [
  {
    id: 'lake-zone',
    src: lake1440,
    srcSet: `${lake960} 960w, ${lake1440} 1440w, ${lake1920} 1920w`,
    width: 1920,
    height: 1080,
    alt: 'Озеро и благоустроенная территория для отдыха в центре Лучезарной Долины',
    placeholder: 'Общий вид благоустроенной зоны у озера',
    recommendedFileName: 'lake.webp',
  },
  {
    id: 'paths-and-lawn',
    alt: 'Прогулочные дорожки, бордюры и газон на общей территории посёлка',
    placeholder: 'Дорожки, бордюры и газон',
    recommendedFileName: 'lake-paths-and-lawn.webp',
  },
  {
    id: 'temporary-pier',
    alt: 'Временный пирс у озера в Лучезарной Долине',
    placeholder: 'Временный пирс',
    recommendedFileName: 'temporary-pier.webp',
  },
  {
    id: 'playground',
    src: playground1440,
    srcSet: `${playground960} 960w, ${playground1440} 1440w, ${playground1920} 1920w`,
    width: 1920,
    height: 1080,
    alt: 'Детская площадка на территории Лучезарной Долины',
    placeholder: 'Детская площадка в естественном окружении',
    recommendedFileName: 'playground.webp',
  },
  {
    id: 'vereskovaya-street',
    src: vereskovaya1440,
    srcSet: `${vereskovaya960} 960w, ${vereskovaya1440} 1440w, ${vereskovaya1920} 1920w`,
    width: 1920,
    height: 1440,
    alt: 'Вересковая улица, ведущая от въезда вглубь посёлка',
    placeholder: 'Вересковая улица в перспективе',
    recommendedFileName: 'vereskovaya.webp',
  },
  {
    id: 'inner-street',
    alt: 'Одна из внутренних улиц Лучезарной Долины',
    placeholder: 'Одна из внутренних улиц',
    recommendedFileName: 'inner-street.webp',
  },
  {
    id: 'entrance',
    src: entrance1440,
    srcSet: `${entrance960} 960w, ${entrance1440} 1440w, ${entrance1920} 1920w`,
    width: 1920,
    height: 1080,
    alt: 'Въездная группа коттеджного посёлка Лучезарная Долина с освещением и автоматическими воротами',
    placeholder: 'Въездная группа и благоустроенная зона',
    recommendedFileName: 'entrance.webp',
  },
  {
    id: 'entrance-lighting',
    alt: 'Освещение въездной группы Лучезарной Долины в вечернее время',
    placeholder: 'Освещение въездной группы вечером',
    recommendedFileName: 'entrance-lighting.webp',
  },
  {
    id: 'office',
    alt: 'Офис рядом с детской площадкой в Лучезарной Долине',
    placeholder: 'Офис рядом с детской площадкой',
    recommendedFileName: 'service-office.webp',
  },
] as const satisfies readonly PlaceMedia[];

export function getPlaceMedia(id: (typeof placeMedia)[number]['id']) {
  const media = placeMedia.find((item) => item.id === id);

  if (!media) throw new Error(`Unknown place media: ${id}`);
  return media;
}
